import { useContext, useState, useEffect } from "react";
import { CartContext } from "../../contexts/CartContext";
import { Link } from "react-router-dom";
import { Timeline } from "../components/Timeline";
import { formatPrice } from "../../utils/formatPrice";
import { validarCupon } from "../../actions/home";
import Swal from "sweetalert2";

export const CarroCompras = () => {
  const {
    cartItems,
    setCartItems,
    removeFromCart,
    cartSummary,
    setCartSummary
  } = useContext(CartContext)

  // console.log("🛒 Productos en el carrito:", cartItems);

  const [cantidades, setCantidades] = useState(cartItems.map(item => item.cantidad || 1))
  const [subtotal, setSubtotal] = useState(0)
  const [descuentoCupon, setDescuento] = useState(0)
  const [costoTotal, setCostoTotal] = useState(0)
  const [cuponAplicado, setCuponAplicado] = useState(false)
  const [cupon, setCupon] = useState("");
  const [showDialog, setShowDialog] = useState(false)
  const [itemsVisibles, setItemsVisibles] = useState(cartItems.map(() => true))
  const [itemToRemove, setItemToRemove] = useState(null)
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0)
  const [cuponCategoriaId, setCuponCategoriaId] = useState(null)


  /* ────────── Sincronizar arrays auxiliares ────────── */
  useEffect(() => {
    setCantidades(cartItems.map(i => i.cantidad || 1))
    setItemsVisibles(cartItems.map(() => true))
  }, [cartItems])

  /* ────────── Recalcular totales ────────── */
  useEffect(() => {
    const nuevoSubtotal = cartItems.reduce(
      (acc, item, idx) => acc + item.productoPrecio * cantidades[idx],
      0
    )

    let subtotalConDescuento = 0
    let aplicaDescuento = false

    if (cuponAplicado) {
      if (cuponCategoriaId === null) {
        subtotalConDescuento = nuevoSubtotal
        aplicaDescuento = true
      } else {
        subtotalConDescuento = cartItems.reduce((acc, item, idx) => {
          if (item.categoriaId === cuponCategoriaId) {
            return acc + item.productoPrecio * cantidades[idx]
          }
          return acc
        }, 0)
      }
    }

    const descuento = (cuponAplicado && aplicaDescuento) ? subtotalConDescuento * (porcentajeDescuento / 100) : 0
    const nuevoCosto = nuevoSubtotal - descuento;

    setSubtotal(nuevoSubtotal)
    setDescuento(descuento)
    setCostoTotal(nuevoCosto)

    setCartSummary({
      subtotal: nuevoSubtotal,
      descuentoCupon: descuento,
      costoTotal: nuevoCosto,
      cartItems,
      cantidades,
      porcentajeDescuento: (cuponAplicado && aplicaDescuento) ? porcentajeDescuento : 0
    });
  }, [cartItems, cantidades, cuponAplicado, porcentajeDescuento, cuponCategoriaId, setCartSummary])

  /* ────────── Handlers de cantidad ────────── */
  const actualizarCantidad = (index, delta) => {
    const nuevasCant = [...cantidades]
    const nuevaCantidad = nuevasCant[index] + delta
    if (nuevaCantidad < 1) return

    nuevasCant[index] = nuevaCantidad
    setCantidades(nuevasCant)

    const nuevosItems = [...cartItems]
    nuevosItems[index].cantidad = nuevaCantidad
    setCartItems(nuevosItems)
  }

  /* ────────── Eliminación ────────── */
  const handleEliminar = idx => {
    setItemToRemove(idx)
    setShowDialog(true)
  }

  const confirmEliminar = () => {
    if (itemToRemove == null) return

    setItemsVisibles(prev =>
      prev.map((v, i) => (i === itemToRemove ? false : v))
    )

    setTimeout(() => {
      const id = cartItems[itemToRemove].productoId
      removeFromCart(id)

      setCantidades(prev => prev.filter((_, i) => i !== itemToRemove))
      setItemsVisibles(prev => prev.filter((_, i) => i !== itemToRemove))

      setShowDialog(false)
      setItemToRemove(null)
    }, 300)
  }

  /* ────────── Cupón ────────── */
  const handleAplicarCupon = async () => {
    if (!cupon) return;

    try {
      const data = await validarCupon(cupon)
      console.log("🎫 Cupón obtenido:", data)
      const porcentaje = Number(data.cuponPorcentajeDescuento) || 0
      const categoriaId = data.categoriaId || null

      if (categoriaId !== null) {
        const hayProductoValido = cartItems.some(item => item.categoriaId === categoriaId)

        if (!hayProductoValido) {
          // Mostrar mensaje de error con Swal y no aplicar el cupón
          Swal.fire({
            position: "center",
            icon: "error",
            title: "El cupón no es válido para los productos en el carrito",
            showConfirmButton: false,
            timer: 3000,
            customClass: {
              container: "custom-body"
            }
          })
          setCuponAplicado(false)
          setPorcentajeDescuento(0)
          setCuponCategoriaId(null)
          return
        }
      }
      setPorcentajeDescuento(porcentaje)
      setCuponCategoriaId(categoriaId)
      setCuponAplicado(true)
    } catch (error) {
      // alert("Cupón inválido o expirado")
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Cupón inválido o expirado",
        showConfirmButton: false,
        timer: 2500,
        customClass: {
          container: 'custom-body'
        }
      })
      setCuponAplicado(false)
      setPorcentajeDescuento(0)
      setCuponCategoriaId(null)
    }
  };


  const handleFinalizarCompra = () => {
    setCartSummary(prev => {
      const updated = { ...prev, cartItems, cantidades }
      // console.log("✅ CartSummary al finalizar compra:", updated);
      return updated
    })
  }

  // useEffect(() => {
  //   console.log("🛒 Se actualizó el carrito:", cartItems);
  // }, [cartItems]);

  useEffect(() => {
    cartItems.forEach(item => {
      console.log(`🧾 Producto: ${item.productoNombre}, categoría ID: ${item.categoriaId}`)
    });
  }, [cartItems])

  return (
    <div className="font-family-montserrat container-carro-commpras">
      <div className="extrabold-800 color-520FDA font20 pad-18 txt-center pad-carrito-compras">
        CARRO DE COMPRAS
      </div>

      <Timeline currentStep={1} />

      <div className="container-cards">
        {cartItems.length === 0 ? (
          <div>No hay artículos en el carrito de compras</div>
        ) : (
          cartItems.map((item, idx) => (
            <div
              key={item.productoId}
              className={`container-card-info flex-container ${itemsVisibles[idx] ? "visible" : "oculto"
                }`}
            >
              <div className="producto-compra flex-container txt-center">
                <img
                  src={item.productoImgUrlPrincipal}
                  alt={item.productoNombre}
                  className="img-carro-compras"
                />
              </div>

              <div className="info-carro-compras">
                <div className="font13 txt-semibold item-descripcion">
                  {item.productoNombre}
                </div>
                <div className="color-A4A4A4 font7 txt-semibold">
                  {item.productoSku}
                </div>

                <div className="precio-info flex-container justify-content">
                  <div className="precio-carro-compras">
                    <div className="color-520FDA txt-semibold precio-actual">
                      {formatPrice(item.productoPrecio)}
                    </div>
                    <div className="precio-anterior colornegro tachado">
                      {formatPrice(item.productoPrecioAnterior)}
                    </div>
                  </div>

                  <div className="br4 color-520FDA btn-agregar flex-container txt-center txt-semibold">
                    <div className="txt-agregar pointer" onClick={() => actualizarCantidad(idx, -1)}>-</div>
                    <div className="pad-txt1 font11">{cantidades[idx]}</div>
                    <div className="txt-agregar pointer" onClick={() => actualizarCantidad(idx, 1)}>+</div>
                  </div>
                </div>
              </div>

              <div className="top-equis pointer" onClick={() => handleEliminar(idx)}>X</div>
            </div>
          ))
        )}

        {cartItems.length > 0 && (
          <>
            {/* ---------- Cupón ---------- */}
            {/* <div className="cupon">
              <div className="container-cupon br6 color-F4F4F flex-container justify-content txt-center">
                <input
                  type="text"
                  className="font10 font700 pad-codigo color-F4F4F"
                  placeholder="CODIGOTOSH"
                  value={cupon}
                  onChange={e => setCupon(e.target.value)}
                  disabled={cuponAplicado}
                />
                {cupon && (
                  <span
                    style={{
                      position: "absolute",
                      right: "70px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "#888"
                    }}
                    onClick={() => {
                      setCupon("");
                      setCuponAplicado(false);
                      setPorcentajeDescuento(0);
                      setCuponCategoriaId(null);
                    }}
                    title="Limpiar cupón"
                  >
                    x
                  </span>
                )}
                <div
                  className={`btn-cupon br6 color-blanco flex-container align-center pointer ${cuponAplicado ? "disabled" : ""
                    }`}
                  onClick={!cuponAplicado ? handleAplicarCupon : undefined}
                >
                  <div className="txt-negrita500 font10-5">Aplicar</div>
                </div>
              </div>
            </div> */}

            <div className="cupon">
              <div className="container-cupon br6 color-F4F4F flex-container justify-content txt-center" style={{ position: "relative" }}>
                <input
                  type="text"
                  className="font10 font700 pad-codigo color-F4F4F"
                  placeholder="CODIGOTOSH"
                  value={cupon}
                  onChange={e => setCupon(e.target.value)}
                  disabled={cuponAplicado}
                />
                {/* Botón X para limpiar */}
                {cupon && (
                  <span
                    style={{
                      position: "absolute",
                      right: "90px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "#7D7D7D"
                    }}
                    onClick={() => {
                      setCupon("");
                      setCuponAplicado(false);
                      setPorcentajeDescuento(0);
                      setCuponCategoriaId(null);
                    }}
                    title="Limpiar cupón"
                  >
                    ×
                  </span>
                )}
                <div
                  className={`btn-cupon br6 color-blanco flex-container align-center pointer ${cuponAplicado ? "disabled" : ""}`}
                  onClick={!cuponAplicado ? handleAplicarCupon : undefined}
                >
                  <div className="txt-negrita500 font10-5">Aplicar</div>
                </div>
              </div>
            </div>

            {/* ---------- Detalle ---------- */}
            <div className="detalle-compra flex-container container-100">
              <div className="font12-semibold">
                <div className="fila1">
                  <div className="column1">Subtotal</div>
                  <div className="column2">{formatPrice(subtotal)}</div>
                </div>

                <div className="fila2 border-top border-bottom">
                  <div className="column1">Cupón</div>
                  <div className="column2 color-520FDA">
                    {cuponAplicado ? `- ${porcentajeDescuento}%` : "-"}
                  </div>
                </div>

                <div className="fila3 border-bottom">
                  <div className="column1">Costo total</div>
                  <div className="column2">{formatPrice(costoTotal)}</div>
                </div>

                <div className="fila4">
                  <div className="column1">Ahorraste</div>
                  <div className="column2">{formatPrice(descuentoCupon)}</div>
                </div>
              </div>
            </div>

            {/* ---------- CTA ---------- */}
            <div className="container-100 flex-container flex-center">
              <Link
                to="/checkout"
                id="btn-finalizar-compra"
                className="color-blanco txt-semibold font15 font16-5 font-family-montserrat enlace-noStyle"
                onClick={handleFinalizarCompra}
              >
                Siguiente
              </Link>
            </div>
          </>
        )}
      </div>

      {showDialog && (
        <div className="dialog-overlay">
          <div className="dialog">
            <p>¿Está seguro que desea eliminar el producto?</p>
            <div className="dialog-buttons flex-container flex-center">
              <div className="dialog-option" onClick={confirmEliminar}>Sí</div>
              <div className="dialog-option" onClick={() => setShowDialog(false)}>No</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};